'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _min = require('./min');

var _min2 = _interopRequireDefault(_min);

var _max = require('./max');

var _max2 = _interopRequireDefault(_max);

var _between = require('./between');

var _between2 = _interopRequireDefault(_between);

var _regex = require('./regex');

var _regex2 = _interopRequireDefault(_regex);

var _email = require('./email');

var _email2 = _interopRequireDefault(_email);

var _not_in = require('./not_in');

var _not_in2 = _interopRequireDefault(_not_in);

var _numeric = require('./numeric');

var _numeric2 = _interopRequireDefault(_numeric);

var _required = require('./required');

var _required2 = _interopRequireDefault(_required);

var _confirmation = require('./confirmation');

var _confirmation2 = _interopRequireDefault(_confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  min: _min2.default,
  max: _max2.default,
  between: _between2.default,
  regex: _regex2.default,
  email: _email2.default,
  not_in: _not_in2.default,
  numeric: _numeric2.default,
  required: _required2.default,
  confirmation: _confirmation2.default
};